module.exports = __webpack_public_path__ + "static/media/flashsale.9f454f27.png";